// extracted by mini-css-extract-plugin
export default {"productDescription":"Qfa-z","featuredDescription":"Rfa-z","description":"Sfa-z","more":"Tfa-z","descriptionSku":"Ufa-z"};